import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { env } from '../config/env.js';
import LandingPage from './LandingPage';
import Login from './Login';
import Register from './Register';
import PasswordGate from './PasswordGate';

const AuthWrapper = ({ children }) => {
  const { user, loading } = useAuth();
  // 'landing' | 'login' | 'register' — used only in full mode
  const [view, setView] = useState('landing');

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 via-indigo-50 to-purple-50">
        <div className="text-center">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-gradient-to-br from-blue-600 to-cyan-600 shadow-lg mb-4">
            <svg className="w-10 h-10 text-white animate-pulse" viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 2L21.5 7v10L12 22 2.5 17V7L12 2z" />
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 9h6M12 6v12M9 15h6" />
            </svg>
          </div>
          <p className="text-gray-600 font-medium">Loading...</p>
        </div>
      </div>
    );
  }

  if (user) {
    return children;
  }

  // Demo mode: landing → password gate (no register flow)
  if (env.IS_DEMO) {
    if (view === 'gate') {
      return <PasswordGate onBack={() => setView('landing')} />;
    }
    return (
      <LandingPage
        onNavigateToLogin={() => setView('gate')}
        onNavigateToRegister={() => setView('gate')}
      />
    );
  }

  if (view === 'register') {
    return (
      <Register
        onSwitchToLogin={() => setView('login')}
        onBack={() => setView('landing')}
      />
    );
  }

  if (view === 'login') {
    return (
      <Login
        onSwitchToRegister={() => setView('register')}
        onBack={() => setView('landing')}
      />
    );
  }

  return (
    <LandingPage
      onNavigateToLogin={() => setView('login')}
      onNavigateToRegister={() => setView('register')}
    />
  );
};

export default AuthWrapper;
